var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart-wave"}},[(_vm.activeChart)?_c('highcharts',{attrs:{"options":_vm.chartOptions,"callback":_vm.onLoad}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }